<template>
  <section role="main" :class="{preview: preview}">
    <validation-observer
        ref="form" tag="form"
        :data-reg-total="state.current_reg.total_wout_addons"
        :data-allow-edit-sections="state.current_reg.allow_edit_sections()"
        novalidate="novalidate"
        class="edit_registration"
        method="post"
        autocomplete="off"
    >
      <div class="row" v-if="!state.current_reg.loaded"><div class="columns"><loader-skeleton /></div></div>
      <Sections :form="$refs.form" />
      <Addons v-if="reg_loaded"/>
      <AdmFees/>
      <Participants :people="people" v2-if="state.current_reg.loaded" />
      <TransferRequestNew 
        v-if="state.current_reg.program.allow_student_transfers"
        :registration="state.current_reg"
        :participants="activeParticipants"
        :reasons="activeReasons"
        :transfer_reasons="state.current_reg.registration_transfer_reasons[0]"
        :transfer_agreements="state.current_reg.registration_transfer_agreements[0]"
        ref="transferForm"
      />
      <!-- <TransferRequest 
        v-if="state.current_reg.program.allow_student_transfers && !allow_new_student_transfer"
        :registration="state.current_reg"
        :participants="activeParticipants"
        :reasons="activeReasons"
        :transfer_reasons="state.current_reg.registration_transfer_reasons[0]"
        :transfer_agreements="state.current_reg.registration_transfer_agreements[0]"
      /> -->
      <div id="participant-content">
        <div v-for="part in filteredFormParts" :key="part.id">
          <div :is="partComponent(part)" :form_part="part" :people="people" />
        </div>
      </div>
      <div v-if="(showVerticalInsure && isDataReady)" class="medical-container-wrapper">
        <div class="medical-container">
          <multi-offer :product="'gap-medical'" :client-id="enable_vertical_insure" :include-payment-element="includePaymentElement"  @offer-state-change="stateChange($event)">
            <gap-medical
              v-for="(coverage, index) in uppercaseSports"
              :key="index"
              :customer-email-address="correctEmail"
              :coverage-start-date="coverageStartDate"
              :coverage-end-date="coverageEndDate"
              :coverage-type="coverage"
              :participant-first-name="correctFirstName"
              :participant-last-name="correctLastName"
              :participant-state="extractedData.state"
              :participant-birth-date="correctBirthdate"
              :coverage-context-description="`Coverage for ${coverage}`"
              :customer-first-name="correctFirstName"
              :customer-last-name="correctLastName"
            />
          </multi-offer>
          <button @click="processPayment" type="button" class="process-payment-btn" :disabled="isReadonly">
            Pay
          </button>
        </div>
      </div>
      <AgreementsRules />
      <NcsaBlock v-if="modalVisibility(state.current_reg.program, 'ncsa')" :registration_id="state.current_reg.id" :program_id="state.current_reg.program.id" :organization_id="state.current_reg.program.organization_id" :ca_ncsa_present="modalVisibility(state.current_reg.program, '')" :program_name="state.current_reg.program.name" :org_name="state.current_reg.program.organization.name"/>
      <CollegeAdvisorBlock v-if="modalVisibility(state.current_reg.program, 'ca')" :registration_id="state.current_reg.id" :program_id="state.current_reg.program.id" :organization_id="state.current_reg.program.organization_id" :ca_ncsa_present="modalVisibility(state.current_reg.program, '')" :program_name="state.current_reg.program.name" :org_name="state.current_reg.program.organization.name"/>
      <RegActions v-if="reg_loaded && !state.current_reg.preview" :form="$refs.form" :edit-tpl="that" :mapper_registration_id="mapper_registration_id" @reload="$emit('reload')" :transfer-form="$refs.transferForm"/>
    </validation-observer>
  </section>
</template>

<script>
import 'templates/shared/notifications'
import "@vertical-insure/web-components"
import moment from 'moment';
import LoaderSkeleton from 'templates/shared/_loader_skeleton'
import filters from './form_block/filters'
import AgreementsRules from './participant/_agreements_and_rules'
import Sections from './_sections'
import Addons from './_addons'
import AdmFees from './_administrative_fees'
import Participants from './_participants'
import TransferRequest from './_transfer_request.vue'
import TransferRequestNew from './_transfer_request_new.vue'
import RegActions from './shared/_actions'
import NcsaBlock from './shared/_ncsa_block'
import CollegeAdvisorBlock from './shared/_college_advisor_block'
import helpers from 'code/base_mixins'
import Policies from "./_policies"

import PartHeader from './form_part/_header'
import PartHeaderConcernsComments from './form_part/header/_concerns_comments'
import PartHeaderMedication from './form_part/header/_medication'

export default {
  name: "RegistrationEdit",
  components: {
    Policies, RegActions, AgreementsRules, AdmFees, Sections, Addons, Participants,
    PartHeader, PartHeaderConcernsComments,PartHeaderMedication, NcsaBlock,
    LoaderSkeleton, CollegeAdvisorBlock, TransferRequest, TransferRequestNew
  },
  mixins: [helpers,filters],
  props:['preview', 'reg_loaded', 'all_loaded', 'people'],
  data() {
    const startDate = moment.utc().add(1, 'day'); // Current date + 1 day
    const endDate = startDate.clone().add(1, 'year'); // Same date + 1 year
    return {
      showVerticalInsure: false,
      coverageStartDate: startDate.format('YYYY-MM-DD'), // Assign formatted start date
      coverageEndDate: endDate.format('YYYY-MM-DD'), // Assign formatted end date
      includePaymentElement: true,
      extractedData: 
      {
        first_name: null,
        last_name: null,
        birth_date: null,
        email: null,
        state: null,
        sports: [],
      },
      isDataReady: false,
      correctBirthdate: "",
      correctEmail: "",
      correctFirstName: "",
      correctLastName: "",
      isReadonly: false,
      mapper_registration_id: null
    };
  },
  computed:{
    that(){ return this },
    filteredFormParts(){
      if (!this.all_loaded) return []
      return this.state.current_reg.program.form_parts.filter(part=> this.notInParticipantParts(part) && part.to_display())
    },
    activeParticipants(){
      return this.state.current_reg.program.participants_info.filter(x => x.active == true)
    },
    activeReasons(){
      return this.state.current_reg.program.transfer_reasons.filter(x => x.active == true)
    },
    environment(){
      return process.env.RAILS_ENV
    },
    enable_vertical_insure(){
      return process.env.VI_CLIENT_ID
    },
    uppercaseSports() {
      return this.extractedData.sports.map(sport => sport.toUpperCase());
    },
  },
  watch: {
    'state.current_reg': {
      handler(newCurrentReg) {
        if (newCurrentReg) {
          const updatedData = {
            first_name: null,
            last_name: null,
            birth_date: null,
            email: null,
            state: null,
            sports: [], // Store multiple sports
          };
          // Process registration_form_blocks
          const formBlocks = newCurrentReg.registration_form_blocks || [];
          if (Array.isArray(formBlocks)) {
            formBlocks.forEach(block => {
              const { handle, style } = block.form_block;
              const entityAttrs = block.entity_attrs;
              if (handle === 'primary' && style === 'Product::FormBlock::PartPerson') {
                updatedData.first_name = entityAttrs.first_name || null;
                updatedData.last_name = entityAttrs.last_name || null;
                updatedData.birth_date = entityAttrs.birth_date || null;
              }
              updatedData.email = this.state.current_user.email;
              if (handle === 'home-address' && style === 'Product::FormBlock::PartAddress') {
                updatedData.state = entityAttrs.state || null;
              }
            });
          }
          // Extract all sports from sections
          const sections = newCurrentReg.registration_sections || [];
          if (Array.isArray(sections)) {
            updatedData.sports = sections
              .filter(section => !section._destroy && section.section?.sport !== undefined && section.section.sport !== null) // Include only selected sections with valid sports
              .map(section => section.section.sport); // Collect sports from selected sections
          }
          // Ensure at least one sport is present
          if (updatedData.sports.length === 0) {
            updatedData.sports = null; // Set to null if no sports are found
          }
          // Update extractedData using $set for reactivity
          Object.keys(updatedData).forEach(key => {
            this.$set(this.extractedData, key, updatedData[key]);
          });
        }
      },
      deep: true,
      immediate: true, // Ensure the handler is triggered immediately when the component is created
    },

    // Watch for changes in extractedData to update isDataReady instantly when a field changes
    'extractedData': {
      handler(newData) {
        const requiredFields = ['birth_date', 'email', 'state']; // Sports handled separately
        // Check if required fields are filled and at least one sport exists
        this.correctBirthdate =  this.generateDummyBirthdate(this.extractedData.birth_date)
        this.correctEmail = "VerticalInsure@arbitersports.com"
        this.correctFirstName = ""
        this.correctLastName = ""
        this.isDataReady =
          requiredFields.every(
            field => newData[field] !== null && newData[field] !== undefined && newData[field] !== ''
          ) && newData.sports !== null; // Ensure at least one sport is present
      },
      deep: true, // Watch nested changes in extractedData
    },
  },
  created() {
    this.checkVerticalInsure();
  },
  methods: {
    async processPayment() {
      try {
        const component = document.querySelector("multi-offer");
        if (!component) {
          throw new Error("multi-offer component not found.");
        }
        const validation = await component.validate();
        if (!validation.isValid) {
          throw new Error("Credit card form validation failed!");
        }
        const paymentToken = await component.getPaymentToken();
        const acceptedQuotes = component.quotes.filter(
          (quote) => quote.selectedState === "ACCEPTED"
        );
        const params = {
          quotes: acceptedQuotes, // Pass the whole quotes object
          payment_method_token: paymentToken,
          program_id: this.state.current_reg.program_id,
        };
        this.mapper_registration_id = params['payment_method_token']
        const response = await this.axios.post(`/api2/organization/vertical_insurance/handle_purchase`, params);
        const backendMessage = response.data.message;
        console.log("Response:", response.data);
        alert(backendMessage);
        this.isReadonly = true;
        this.includePaymentElement = false;
      } catch (error) {
        console.error("Payment Processing Error:", error);
        const errorMessage = error.response?.data?.message || error.message || "An error occurred during payment processing.";
        this.paymentError = errorMessage;
        alert(`Error: ${this.paymentError}`);
      }
    },
    generateDummyBirthdate(realBirthdate) {
      const realDate = moment(realBirthdate).utc(); // Parse the real birthdate in UTC
      const currentDate = moment().utc(); // Get current date in UTC
      // Calculate the age
      let age = currentDate.year() - realDate.year();
      // Check if the birthday has passed this year
      const birthdayThisYear = moment(currentDate).month(realDate.month()).date(realDate.date()).utc();
      if (currentDate.isBefore(birthdayThisYear)) {
        age--; // If the birthday hasn't passed yet this year, subtract one from age
      }
      // Create the dummy birthdate with the corrected year, static day (1), and static month (0 for January)
      const dummyYear = currentDate.year() - age;
      const dummyDay = 1; // Static day
      const dummyMonth = 0; // Static month (January is 0)
      return moment.utc([dummyYear, dummyMonth, dummyDay]).format('YYYY-MM-DD'); // Return the date in UTC format
    },
    stateChange(e){
      if (e.target.selectedState === 0){
        this.correctBirthdate = this.extractedData.birth_date;
        this.correctEmail = this.extractedData.email;
        this.correctFirstName = this.extractedData.first_name;
        this.correctLastName = this.extractedData.last_name;
      } else {
        this.correctBirthdate = this.generateDummyBirthdate(this.extractedData.birth_date);
        this.correctEmail = "VerticalInsure@arbitersports.com";
        this.correctFirstName = "";
        this.correctLastName = "";
      }
    },
    partComponent(part){
      return this.$options.components["PartHeader"+part.style] ? "PartHeader"+part.style : "PartHeader"
    },
    notInParticipantParts(part){
      return !(part.style === 'RegistrantInformation' || part.style === 'Address')
    },
    modalVisibility(program, modal_type){
      const program_type = program.program_type;
      const disable_ncsa = program.organization.disable_ncsa;
      if(modal_type == '' && !disable_ncsa && (!program_type || program_type == "combined")){
        return true
      }else if(modal_type == "ncsa" && !disable_ncsa && ["athletic", "combined", "coaches"].includes(program_type)){
        return true
      }else if(modal_type == "ca" && !disable_ncsa && ["non_athletic", "combined", "field_trip", "event", "elective", "camp", "class", "club", "workshop"].includes(program_type)){
        return true
      }else{
        return false
      }
    },
    verticalInsureDisable() {
      const org = this.state.current_reg.program.organization;
      const type_of_program = this.state.current_reg.program.program_type;
      return (
        !org.disable_vertical_insure && 
        type_of_program === 'athletic'
      )
    },
    checkVerticalInsure() {
      this.showVerticalInsure = this.verticalInsureDisable();
    },
  },
  
  destroyed(){ this.$store.commit('unloadReg') }
}
</script>
<style scoped>
.preview{
  padding-bottom: 0 !important;
}
input[aria-invalid="true"] {
  border-color: #b61e11;
}
</style>

<style lang="scss">
$color-red: #b61e11;

.edit_registration{
  label.error, .int-tel-input-wapper.error {
    input, textarea, .select{
      border-color: $color-red;
      background-color: rgba($color-red, 0.2) !important;
    }
  }
  .ant-upload-drag-input.error{
    .ant-upload-drag{
      background-color: rgba($color-red, 0.2) !important;
    }
  }
}
.ncsa-margin{
  margin-left: 112px;
}
.ncsa-logo-margin{
  margin-left: -17px;
}
.parellel-div{
  float: left;
  width: 41%;
}
.ca-margin{
  margin-left: -8px;
}
.ca-height{
  height: 73px;
}
.ca_logo-margin{
  margin-left: -21px;  
}
.preview{
  .parellel-div{
   .ncsa_promo_text{
      margin-left: 130px;
      margin-top: -150px;
      position: relative;
   }   
  }
  .ncsa-margin{
    margin-left: 1px;
  }
  .preview-height{
    height: 340px;
  }
  .parellel-div{
    float: left;
    width: 50%;
  }
  .ca-height{
    height: 72px;
  }
  .ca-content{
    margin-top: 0;
  }
}
.ca-content{
  @media (max-width:480px) { 
    margin-top: 0;
  }
  @media screen and (orientation:landscape) 
  and (max-width:480px){
    
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) { 
    margin-top: -383px;
  }

  @media only screen and (min-width: 540px) and (max-width: 720px) { 
    margin-top: 0;
  }
  @media only screen and (min-width: 820px) and (max-width: 1180px) { 
    margin-top: -364px;
  }
  @media only screen and (min-width: 768px) and (max-width: 768px) { 
    margin-top: -396px;
  }
  float: right;
  margin-top: -318px;
 .content{
    @media (max-width: 768px) {
      height: auto;
    }
    @media only screen and (min-width: 820px) and (max-width: 1180px) { 
      height: 266px;
    }
    height: 220px;
  }
 .college_advisor_logo{
    @media (max-width: 768px) {
      padding-bottom: 0;
    }
    @media only screen and (min-width: 820px) and (max-width: 1180px) { 
      padding-bottom: 0;
      margin-top: -13px;
      height: 62px;
    }
    padding-bottom: 10px;
 }
}
.ncsa-content{
  float: left;
  .ncsa_logo{
    width: 130px;
  }
  .content{
    @media only screen and (min-width: 820px) and (max-width: 1180px) { 
      height: 266px;
    }
  }
}
.medical-container-wrapper {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: flex-start; /* Adjust vertical alignment as needed */
  background: white;
  padding: 8px;
  margin-bottom: 1.5rem;
  width: 100%; /* Takes full width of the screen */
}

.medical-container {
  background: white;
  width: 59rem;
  max-width: 90%; /* Ensures responsiveness for smaller screens */
  box-sizing: border-box; /* Include padding in the width calculation */
}
.process-payment-btn{
  float: right;
  margin-right: 1rem;
  margin-top:-1rem;
}
</style>
